/**
 * Enum containing all feature codes used in the application.
 * These codes must match the featureCode values returned from the API.
 */
export enum FeatureCode {
  EQUIPMENT_REPORT = 'EQUIPMENT_REPORT',
}
